import { render, staticRenderFns } from "./ListEventosHome2.vue?vue&type=template&id=d36a6572&"
import script from "./ListEventosHome2.vue?vue&type=script&lang=js&"
export * from "./ListEventosHome2.vue?vue&type=script&lang=js&"
import style0 from "./ListEventosHome2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports